import { ComparisonTableFrame } from '~/src/components/ui/ComparisonTableFrame'
import type {
  HubComparisonTableSection,
  HubSectionComponentProps,
} from './types'

export function HubComparisonTable({
  section,
}: HubSectionComponentProps<HubComparisonTableSection>) {
  if (section.columns.length === 0 || section.rows.length === 0) return null

  return (
    <section id={section.id} className='flex min-w-0 flex-col gap-5'>
      {section.title && (
        <h2 className='font-display text-2xl font-bold leading-8 text-foreground'>
          {section.title}
        </h2>
      )}
      {section.dek && (
        <p className='text-base leading-6 text-foreground-secondary'>
          {section.dek}
        </p>
      )}

      <ComparisonTableFrame
        caption={section.title}
        labelColumnName='Field'
        minWidth={Math.max(600, section.columns.length * 160 + 160)}
        columnWidth={`${100 / (section.columns.length + 1)}%`}
        columns={section.columns.map((col) => ({
          key: col.slug,
          highlighted: col.isHighlighted,
          header: <span className='line-clamp-2 text-balance'>{col.name}</span>,
        }))}
        rows={section.rows.map((row, rowIndex) => ({
          key: `${row.label}-${rowIndex}`,
          label: row.label,
          cells: row.values.map((value) => value ?? '—'),
        }))}
      />
    </section>
  )
}
